/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRotateRight: {
  name: 'arrow-rotate-right';
  data: string;
} = {
  name: 'arrow-rotate-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 12a9 9 0 0 1 9-9 9.15 9.15 0 0 1 6 2.244V4a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.957A7.151 7.151 0 0 0 12 5a7 7 0 1 0 7 7 1 1 0 1 1 2 0 9 9 0 1 1-18 0Z" fill="currentColor"/></svg>`,
};
